import { SlapStickerMaker } from '@/pages/SlapStickerMaker/SlapStickerMaker'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/slap-sticker-maker/')({
  component: SlapStickerMakerPage,
  head: () => ({
    meta: [
      {
        title: 'Slap Sticker Maker - Enablar',
      },
      {
        name: 'description',
        content:
          'Create printable slap stickers with vertical text on A4 pages.',
      },
    ],
  }),
})

function SlapStickerMakerPage() {
  return <SlapStickerMaker />
}
